export const formatPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/g, "");
  if (!digits) return "";

  if (digits.length <= 2) {
    return `(${digits}`;
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }

  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

export const formatPersonName = (value: string) => {
  if (!value) return "";
  const raw = value.replace(/[\x00-\x1F\x7F]/g, " ").trim().replace(/\s+/g, " ");
  if (!raw) return "";

  const minorWords = new Set([
    "da", "das", "de", "do", "dos", "e",
    "del", "della", "di", "du", "van", "von",
  ]);

  const capToken = (token: string, isFirst: boolean) => {
    const lower = token.toLowerCase();
    if (!isFirst && minorWords.has(lower)) return lower;
    if (/^\d+$/.test(token)) return token;

    return lower
      .split("-")
      .filter(Boolean)
      .map((p) =>
        p
          .split("'")
          .map((ap) => (ap ? ap.charAt(0).toUpperCase() + ap.slice(1) : ap))
          .join("'")
      )
      .join("-");
  };

  const parts = raw.split(" ").filter(Boolean);
  return parts.map((p, idx) => capToken(p, idx === 0)).join(" ");
};
